<template>

  <div class="modal " id="confirmBoxModal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content border border-warning rounded">
      <div  class="modal-header border border-warning bg-warning">  
        
        <h4 class="modal-title"><strong>
          <i style="color:black" class="	fas fa-exclamation mr-3" aria-hidden="true"></i>   
        {{ props.title }}  
        </strong> </h4>       
      </div>
      <div class="modal-body">
         <strong> <p>            
            <!--<i style="color:red;font-size:20px" class="fas fa-exclamation-triangle mr-3" aria-hidden="true"></i> -->
            {{ props.msg }}
             </p>           
             PROCEDO ? </strong>
        
      </div>

      <div class="modal-footer">
        <button type="button" @click="closeModal()" class="btn btn-secondary">NO</button>        
        <button @click="closeModal('update')" type="button" class="btn btn-primary">SI</button>
        
      </div>
    </div>
  </div>
  </div>
  
</template>
<script>
    
export default {
  props   : ['props'],
  created : function()
  {
    this.$nextTick(()  => {                  
        $('#confirmBoxModal').modal('show')
    
    })  
  },
  methods :
  {
    closeModal(type)
    {
      $('#confirmBoxModal').modal('hide')
      this.$nextTick(()  => {   
        if(type=='update')
        {
          this.props.method()          
        }
        this.$emit('close')        
      })    
    }, 
     
   
  }
}
</script>    
<style scoped>
h4{
  font-size: 20px;
}
.modal-footer {  
  justify-content: space-between;  
}

</style>
